import type { ReactNode } from 'react'
import { FilterX, Search } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

interface WasteTypesToolbarProps {
  search: string
  onSearchChange: (value: string) => void
  onClearFilters: () => void
  hasActiveFilters: boolean
  children?: ReactNode
}

export function WasteTypesToolbar({
  search,
  onSearchChange,
  onClearFilters,
  hasActiveFilters,
  children,
}: WasteTypesToolbarProps) {
  return (
    <div className="flex flex-col items-start gap-3 xl:flex-row xl:flex-wrap xl:items-center">
      <div className="relative w-full xl:w-auto xl:min-w-[20rem] xl:max-w-sm">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar tipos de residuo..."
          className="h-10 border-border bg-background pl-9"
          aria-label="Buscar tipos de residuo"
        />
      </div>

      {children}

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={onClearFilters}
        disabled={!hasActiveFilters}
        className="h-10 w-10 shrink-0 border-border bg-background p-0 hover:bg-accent"
        aria-label="Limpiar filtros"
        title="Limpiar filtros"
      >
        <FilterX className="h-4 w-4" />
      </Button>
    </div>
  )
}
